/** TTL do cache de domínio na sessão do browser. */
export const DOMAIN_CACHE_TTL_MS = 5 * 60 * 1000;

/**
 * Mapa dominio da API (`/api/dominios/{dominio}/...`) → keys exatas do DomainCacheService.
 */
export const DOMAIN_CACHE_KEYS: Record<string, string[]> = {
  TIPO_ENTIDADE: ['tipo-entidade'],
  STATUS_ENTIDADE: ['status-entidade'],
  SITUACAO_ASSOCIADA: ['situacao-entidade/combo'],
  GRUPO_ECONOMICO: ['grupo-economico/combo'],
  GRUPO_ATUALIZACAO: ['grupo-atualizacao/combo'],
  TIPO_ORGAO: ['tipo-orgao/combo'],
  ESPECIALIZACAO_SUB_TIPO_ENTIDADE: ['tipo-orgao/combo'],
  TIPO_COMISSAO: ['tipo-comissao'],
  CARGO_REFERENCIA: ['cargo-referencia'],
  STATUS_VALIDACAO: ['status-validacao/combo'],
  TIPO_DOCUMENTO: ['tipo-documento/combo'],
  TRATAMENTO: ['tratamento'],
  TIPO_RELACAO: ['tipo-relacao'],
  TIPO_ENVOLVIMENTO: ['tipo-envolvimento'],
  TIPO_REGULADORA: ['tipo-reguladora'],
  TIPO_GRUPO: ['tipo-grupo/combo'],
  AREA_ATUACAO: ['area-atuacao/combo'],
};

/**
 * Prefixos a invalidar além das keys exatas (combos parametrizados).
 */
export const DOMAIN_CACHE_PREFIXES: Record<string, string[]> = {
  CARGO_REFERENCIA: ['cargo-referencia/'],
  TIPO_CONTATO: ['tipo-contato/combo'],
  GRUPO: ['grupo/combo/'],
};
